<div
  class="flex flex-col scrollbar"
  [class]="embedded() ? 'flex-1 min-h-0' : 'h-full'"
>
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <form
      class="flex flex-1 flex-col p-4 text-xs space-y-2"
      [formGroup]="form.group"
    >
      <kendo-formfield>
        <kendo-label
          [for]="dueDate"
          [text]="('outlook.task.dueDate' | translate) + '*'"
        >
        </kendo-label>
        <kendo-datetimepicker
          #dueDate
          [format]="outlookStore.fullDateTimeFormat()"
          formControlName="dueDate"
          calendarType="classic"
          required
        >
        </kendo-datetimepicker>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="('outlook.task.activity' | translate) + '*'">
        </kendo-label>
        <kendo-textarea
          [rows]="6"
          resizable="vertical"
          formControlName="activity"
        ></kendo-textarea>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="'outlook.task.priority' | translate"></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.options?.priorities"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="priority"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [for]="primaryContact"
          [text]="'outlook.task.assignedUser' | translate"
          >*
        </kendo-label>

        <kendo-dropdownlist
          [data]="configuration?.users"
          textField="name"
          valueField="id"
          fillMode="solid"
          [valuePrimitive]="true"
          formControlName="assignedUser"
          #primaryContact
        >
        </kendo-dropdownlist>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="'outlook.task.category' | translate"></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.options?.categories"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="category"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="'outlook.task.result' | translate"></kendo-label>
        <kendo-dropdownlist
          [data]="configuration?.options?.results"
          textField="name"
          valueField="id"
          fillMode="solid"
          formControlName="result"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </kendo-formfield>
    </form>
  }

  <div
    class="bg-neutral-5 z-40 mt-auto flex justify-end gap-2 p-2 bottom-0 sticky"
  >
    <button
      kendoButton
      id="outlook-task-ui-addTask-cancel"
      rounded="large"
      class="uppercase"
      themeColor="primary"
      fillMode="flat"
      (click)="cancel()"
      [disabled]="loading"
    >
      {{ 'outlook.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      id="outlook-task-ui-addTask-save"
      class="uppercase"
      themeColor="primary"
      [disabled]="!form?.valid"
      (click)="save()"
    >
      {{ 'outlook.buttons.save' | translate }}
    </button>
  </div>
</div>

<maximizer-outlook-notification #notification [closable]="true" entryId="task">
</maximizer-outlook-notification>
